import { Link } from "@chakra-ui/react";

export const DEAL_URL_TEMPLATE =
  "https://alforest.bitrix24.ru/crm/deal/details/{value}/";

export function dealHref(id) {
  return DEAL_URL_TEMPLATE.replace("{value}", String(id));
}

/**
 * Ссылка на сделку Битрикса. Одна на все отчёты, чтобы вид и адрес не
 * разъезжались: раньше в каждом отчёте она была своя, и в двух из них ID
 * выводился как число с разделителями разрядов.
 *
 * isExternal у Chakra проставляет target="_blank" и rel="noopener noreferrer",
 * то есть сделка открывается в новом окне и не даёт открытой странице доступ
 * к вкладке дашборда.
 */
const DealLink = ({ id, children }) => (
  <Link
    href={dealHref(id)}
    isExternal
    textDecoration="underline"
    color="white"
    _hover={{ color: "blue.500" }}
  >
    {children ?? String(id)}
  </Link>
);

export default DealLink;
